import React, { useRef, useState } from "react";
import { PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function AddInput(props) {

    const [value, setValue] = useState('');
    const inputRef = useRef(null);
    const addButtonLabel = props.addButtonLabel || "Agregar";
    const deleteLabel = props.deleteLabel || "Eliminar";
    const commitValue = () => {
        const trimmedValue = value.trim();
        if (!trimmedValue) return;

        props.handleChange(props.name, trimmedValue);
        setValue('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            commitValue();
            e.stopPropagation();
            e.preventDefault();
        } else if (props.onlyNumbers) {
            const allowedKeys = [
                "Backspace",
                "Delete",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Home",
                "End",
            ];
            if (
                !/^\d$/.test(e.key) &&
                !allowedKeys.includes(e.key) &&
                !e.ctrlKey &&
                !e.metaKey
            ) {
                e.preventDefault();
            }
        }
    };

    return (
        <div className={props.containerClassName}>
            <label htmlFor={props.name} className="text-sm font-medium text-gray-700 dark:text-gray-200">
                {props.label}
                {props.required ? <p className="font-medium text-[#F51515] inline-block ml-2"> *</p> : null}
            </label>
            <div className="mt-1 flex flex-col gap-2 sm:flex-row">
                <input
                    onChange={(event) => setValue(event.target.value)}
                    type='text'
                    name={props.name}
                    id={props.name}
                    ref={inputRef}
                    value={value}
                    placeholder={props.placeholder}
                    className={props.className ? props.className : "min-h-[44px] w-full rounded-xl border border-slate-300 bg-white px-3 shadow-sm focus:border-primary focus:ring-primary dark:border-slate-700 dark:bg-slate-950"}
                    disabled={props.disabled}
                    maxLength={props.maxLength}
                    onKeyDown={handleKeyDown}
                    onBlur={commitValue}
                    aria-describedby={`${props.name}-description`}
                />
                <button
                    type="button"
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => {
                        commitValue();
                        inputRef.current?.focus();
                    }}
                    disabled={!value.trim() || props.disabled}
                    className="inline-flex min-h-[44px] shrink-0 items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm transition hover:border-primary/40 hover:text-primary disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
                >
                    <PlusIcon className="h-4 w-4" aria-hidden="true" />
                    {addButtonLabel}
                </button>
            </div>
            {props?.value?.length > 0 &&
                <div className="mt-3 flex flex-wrap gap-2">
                    {props.value.map((element, idx) => (
                        <div
                            key={`${props.name}-${idx}`}
                            className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
                        >
                            <span>
                                {props.unit} {idx + 1}:{" "}
                                {typeof element === 'object' ? element.number : element}
                            </span>
                            <button
                                type="button"
                                onClick={() => props.handleDelete(idx)}
                                className="rounded-full text-slate-400 transition hover:text-red-600"
                            >
                                <span className="sr-only">{deleteLabel}</span>
                                <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                            </button>
                        </div>
                    ))}
                </div>
            }
            {props.errorMessage && <p className="mt-2 text-sm text-red-600" id={`${props.name}-error`}>
                {props.errorMessage}
            </p>}
        </div >
    )

}
